import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import useWidgetConfiguration from "data-lake/preview/hooks/useWidgetConfiguration";
const useUpdateTableFilter = (setFieldValue) => {
  const { resetWidget } = useWidgetConfiguration();
  const { setDataLakeFieldsFetchQuery } = useSelectedDataLake();
  return (tableId) => {
    resetWidget();
    setFieldValue("fields.fieldFilters", []);
    setFieldValue("table", tableId);
    setDataLakeFieldsFetchQuery((cur) => ({ ...cur, tableId }));
  };
};
export default useUpdateTableFilter;
